import { render, staticRenderFns } from "./SortableTask.vue?vue&type=template&id=2f2f3546"
import script from "./SortableTask.vue?vue&type=script&lang=js"
export * from "./SortableTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports